import React from "react";
import styles from "./index.module.scss";

export const BadgeIcon = () => {
    return (
        <svg
            width="16"
            height="21"
            viewBox="0 0 16 21"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M6.925 10.75L8 9.925L9.05 10.75C9.25 10.9 9.45 10.9042 9.65 10.7625C9.85 10.6208 9.91667 10.4333 9.85 10.2L9.425 8.85L10.625 7.9C10.8083 7.75 10.8625 7.5625 10.7875 7.3375C10.7125 7.1125 10.5583 7 10.325 7H8.9L8.475 5.675C8.39167 5.44167 8.23333 5.325 8 5.325C7.76667 5.325 7.60833 5.44167 7.525 5.675L7.1 7H5.675C5.425 7 5.2625 7.1125 5.1875 7.3375C5.1125 7.5625 5.16667 7.75 5.35 7.9L6.55 8.85L6.125 10.2C6.04167 10.4333 6.10417 10.6208 6.3125 10.7625C6.52083 10.9042 6.725 10.9 6.925 10.75ZM3.325 20.55C2.99167 20.6667 2.6875 20.625 2.4125 20.425C2.1375 20.225 2 19.9583 2 19.625V13.275C1.36667 12.575 0.875 11.775 0.525 10.875C0.175 9.975 0 9.01667 0 8C0 5.76667 0.775 3.875 2.325 2.325C3.875 0.775 5.76667 0 8 0C10.2333 0 12.125 0.775 13.675 2.325C15.225 3.875 16 5.76667 16 8C16 9.01667 15.825 9.975 15.475 10.875C15.125 11.775 14.6333 12.575 14 13.275V19.625C14 19.9583 13.8625 20.225 13.5875 20.425C13.3125 20.625 13.0083 20.6667 12.675 20.55L8 19L3.325 20.55ZM8 14C9.66667 14 11.0833 13.4167 12.25 12.25C13.4167 11.0833 14 9.66667 14 8C14 6.33333 13.4167 4.91667 12.25 3.75C11.0833 2.58333 9.66667 2 8 2C6.33333 2 4.91667 2.58333 3.75 3.75C2.58333 4.91667 2 6.33333 2 8C2 9.66667 2.58333 11.0833 3.75 12.25C4.91667 13.4167 6.33333 14 8 14Z"
                className={styles.badgeIcon}
            />
        </svg>
    );
};
